<section style="height: calc(100% - 70px);">
    <h2>Create new Project</h2>
    <app-vcl-filter [pageId]="pageId" [filterType]="'institution'" [userInfos]="userInfos" [modes]="modes" [platformInfos]="platformInfos" (filterDataOutputEvent)="sendFilterData($event)">
    </app-vcl-filter>
    <app-project-creation [userInfos]="userInfos" [filterData]="filterData" [platformInfos]="platformInfos" (inProgress)="setProgress($event)"></app-project-creation>
</section>